import * as React from 'react';
import Table from "../../atom/table/table";
import DefaultColgroup from "../../atom/table/default_colgroup";
import Tbody from "../../atom/table/tbody";
import Tr from "../../atom/table/tr";
import ThWithText from "../../atom/table/th_with_text";
import TdWithText from "../../atom/table/td_with_text";
import {companyConfig} from "../../../../config/language/ja-JP/domain/model_text";
import {Business, Company} from "../../../../domain/model/company";
import Paragraph from "../../atom/text/paragraph";
import styled from "styled-components";


interface IProps {
    company: Company | null;
}

export const TableCompanyInfo: React.FC<IProps> = (props) => {
    const {
        company
    } = props;

    if (!company) {
        return (<div/>)
    }

    const companyName: string = company.name;
    const createBusinessArray: string[] = company.business.map((item: Business) => {
        return (
            companyConfig.businessList[item]
        )
    });
    const businessString: string = createBusinessArray.join(',');

    return (
        <React.Fragment>
            <Table>
                <DefaultColgroup/>

                <Tbody>
                    <Tr>
                        <ThWithText>企業名</ThWithText>
                        <TdWithText colSpan={3}>{companyName}</TdWithText>
                    </Tr>
                    <Tr>
                        <ThWithText>設立年月日</ThWithText>
                        <TdWithText colSpan={3}>{company.getEstablishedAtString()}</TdWithText>
                    </Tr>
                    <Tr>
                        <ThWithText>郵便番号</ThWithText>
                        <TdWithText colSpan={3}>{company.postalCode}</TdWithText>
                    </Tr>
                    <Tr>
                        <ThWithText>所在地</ThWithText>
                        <TdWithText colSpan={3}>{company.place}</TdWithText>
                    </Tr>
                    <Tr>
                        <ThWithText>企業 WEB URL</ThWithText>
                        <TdWithText colSpan={3}>{company.webURL}</TdWithText>
                    </Tr>
                    <Tr>
                        <ThWithText>業種</ThWithText>
                        <TdWithText>{businessString}</TdWithText>
                        <ThWithText>従業員規模</ThWithText>
                        <TdWithText>{companyConfig.employeeScaleList[company.employeeScale]}</TdWithText>
                    </Tr>
                    <Tr>
                        <ThWithText>CEO名前</ThWithText>
                        <TdWithText>{company.representativeName}</TdWithText>
                        <ThWithText>資本金</ThWithText>
                        <TdWithText>{company.getCapitalStockString()}</TdWithText>
                    </Tr>
                    <Tr>
                        <ThWithText>会社紹介メッセージ</ThWithText>
                        <TdWithText colSpan={3}>{company.introduction}</TdWithText>
                    </Tr>
                </Tbody>
            </Table>

            <AccordingInfoWrapper><Paragraph bold={true}>請求先情報</Paragraph></AccordingInfoWrapper>

            <Table>
                <Tbody>
                    <Tr>
                        <ThWithText>請求先名</ThWithText>
                        <TdWithText colSpan={3}>{company.accordingCompanyName}</TdWithText>
                    </Tr>
                    <Tr>
                        <ThWithText>請求先郵便番号</ThWithText>
                        <TdWithText colSpan={3}>{company.accordingCompanyPostalCode}</TdWithText>
                    </Tr>
                    <Tr>
                        <ThWithText>請求先住所</ThWithText>
                        <TdWithText colSpan={3}>{company.accordingCompanyAddress}</TdWithText>
                    </Tr>
                    <Tr>
                        <ThWithText>請求先部署</ThWithText>
                        <TdWithText colSpan={3}>{company.invoiceDepartmentName}</TdWithText>
                    </Tr>
                </Tbody>
            </Table>

        </React.Fragment>

    )

};

export default TableCompanyInfo;

const AccordingInfoWrapper = styled.div`
    margin: 40px 0 20px 0;
`;



// WEBPACK FOOTER //
// ./src/presentation/common/template/table/table_company_info.tsx